import styled from 'styled-components';

const StatusLabel = styled.div`
  font-weight: 600;
  font-size: 12px;
  text-transform: capitalize;
  svg {
    margin: 0 4px 0 0;
  }
  &.Active {
    color: ${p => p.theme.statusActive};
  }
  &.Expired {
    color: ${p => p.theme.statusInActive};
  }
  &.Closed {
    color: ${p => p.theme.statusClosed};
  }
  &.Overdue {
    color: ${p => p.theme.statusOverDue};
  }
  @media (min-width: 768px) and (max-width: 992px) {
    font-size: 10px;
  }
  @media (min-width: 992px) and (max-width: 1023px) {
    font-size: 10px;
  }
  @media (min-width: 1024px) and (max-width: 1279px) {
    font-size: 10px;
  }
  @media (min-width: 1280px) and (max-width: 1365px) {
    font-size: 11px;
  }
  @media (min-width: 1366px) and (max-width: 1439px) {
    font-size: 11px;
  }
  @media (min-width: 1440px) and (max-width: 1600px) {
    font-size: 11px;
  }
`;
const NoDataFoundLabel = styled.label`
  font-family: 'Open sans';
  font-size: 20px;
  font-weight: 400;
  color: #616161;
  margin: 5px 0 12px 0;
  text-transform: capitalize;
  display: block;
  line-height: 20px;
`;
const NoDataFoundSubLabel = styled.label`
  font-family: 'Open sans';
  font-size: 16px;
  font-weight: 400;
  color: grey;
  margin: 5px 0;
  display: block;
  line-height: 24px;
`;
export { StatusLabel, NoDataFoundLabel, NoDataFoundSubLabel };
